import FieldSet from '../../FieldSet';

import { IdeaCategories } from './IdeaCategories';

export class IdeaCategoriesFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [IdeaCategories];
  }

  get title() {
    return 'Categories';
  }
}
